/*
 * @Author: monai
 * @Date: 2021-05-11 15:34:05
 * @LastEditors: muqing
 * @LastEditTime: 2024-08-29 16:47:13
 */
import {getQueryString} from '@activity-business/h5-package-frameworkTool';
import { createApp } from 'vue';

let getCountryCode: DevelopToolShare.GetCountryCode = (app, countryCode)=>{
    //  未获取到、未使用固定国家码参数 默认 EN
    let code: string = countryCode? countryCode: (getQueryString('lang')?.toUpperCase() || 'EN'),
    //  需要反转的国家简称
    rtlCountry: string[] = ['EG', 'XM', 'ME', 'AR'];

    document.body.style.direction = rtlCountry.includes(code) ? 'rtl' : 'initial';
    //  统一添加国家码ID
    document.body.setAttribute('id', code);

    return code;
};

export default getCountryCode;